import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';

import { PlanningTypes } from '../context/types/contextPrevision.type';

export interface UseEditCompleteBody {
	planningType: PlanningTypes;
	cycleId: number;
	companyAreaId: number;
	isComplete: boolean;
}

export const useEditComplete = (
	onSuccess?: () => void,
	onTostSuccess: boolean = false
) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation({
		mutationFn: ({
			planningType,
			cycleId,
			companyAreaId,
			isComplete,
		}: UseEditCompleteBody) => {
			return api.put(`/${planningType}/is-complete`, {
				cycle_id: cycleId,
				company_area_id: companyAreaId,
				is_completed: isComplete,
			});
		},
		onSuccess: (_, { planningType }) => {
			queryClient.invalidateQueries({
				queryKey: ['is-complete'],
			});
			queryClient.invalidateQueries({
				queryKey: [`${planningType}-list`],
			});
			onSuccess?.();
			if (onTostSuccess) {
				toast({
					title: 'Finalização realizada com sucesso!',
					description: '',
					status: 'success',
					position: 'bottom-left',
					duration: 3000,
					isClosable: true,
				});
			}
		},
	});
};
